import { render, staticRenderFns } from "./Zhengshu.vue?vue&type=template&id=6501a394&scoped=true&"
import script from "./Zhengshu.vue?vue&type=script&lang=js&"
export * from "./Zhengshu.vue?vue&type=script&lang=js&"
import style0 from "./Zhengshu.vue?vue&type=style&index=0&id=6501a394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6501a394",
  null
  
)

export default component.exports